"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = require("@mui/material/Grid");
var React = require("react");
var text_filed_component_1 = require("../../../../../common/text_filed/text_filed_component");
var text_field_with_datepicker_1 = require("../../../../../common/text_filed/text_field_with_datepicker");
var drop_down_component_1 = require("../../../../../common/drop_down/drop_down_component");
var react_redux_1 = require("react-redux");
var DetailField = function (_a) {
    var fieldKey = _a.fieldKey, lableName = _a.lableName, value = _a.value, className = _a.className, grid_size = _a.grid_size, isEditable = _a.isEditable, fieldType = _a.fieldType, isSectionEdit = _a.isSectionEdit, textFieldOnchangeHandler = _a.textFieldOnchangeHandler, dateFieldOnchangeHandler = _a.dateFieldOnchangeHandler, dropdownOnchangeHandler = _a.dropdownOnchangeHandler, showEmpty = _a.showEmpty;
    var billing_modules = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList; }).billing_modules;
    var getDropdownList = function (filedname) {
        switch (filedname) {
            case 'Billing Module':
                return billing_modules;
            default:
                return [];
        }
    };
    var fieldsWrapper = function () {
        return (React.createElement(Grid_1.default, { sx: { display: 'flex' } },
            React.createElement(Grid_1.default, { sm: 7 }, fieldType === 'string' ?
                React.createElement(text_filed_component_1.default, { compact: true, onChange: function (value) { return textFieldOnchangeHandler(value, fieldKey); } })
                : fieldType === 'date' ?
                    React.createElement(text_field_with_datepicker_1.default, { compact: true, onChange: function (value) { return dateFieldOnchangeHandler(value, fieldKey); } })
                    : fieldType === 'dropdown' ?
                        React.createElement(drop_down_component_1.default, { dropDownList: getDropdownList(lableName), placeholder: "Select ".concat(lableName), value: value, onChange: function (value) { return dropdownOnchangeHandler(value, fieldKey, lableName); }, compact: true })
                        : React.createElement(React.Fragment, null))));
    };
    return ((value !== '' && value !== '--' || isEditable && isSectionEdit || showEmpty) &&
        React.createElement(Grid_1.default, { item: true, xs: grid_size ? grid_size : 6, className: "user-profile-wrapper" },
            React.createElement("small", { className: "user-label" }, lableName),
            isEditable && isSectionEdit
                ? fieldsWrapper()
                : (React.createElement("p", { className: "user-value ".concat(className || '') }, typeof value === "boolean"
                    ? value ? "Yes" : "No"
                    : typeof value === 'string' && value
                        ? value.charAt(0).toUpperCase() + value.slice(1)
                        : typeof value === 'object' && value ? value.label
                            : value || "--"))));
};
exports.default = DetailField;
